import { type ElementType } from 'react'
import {
  Card,
  CardContent,
  Label,
  RadioButton,
  Text,
} from '@asus-common/fe-ui-shadcn'
import clsx from 'clsx'

interface RadioCardProps {
  id: string
  description: string
  icon: ElementType
  selected: boolean
  title: string
  value: string
}

export function RadioCard({
  id,
  value,
  icon: Icon,
  title,
  description,
  selected,
}: RadioCardProps) {
  return (
    <Label htmlFor={id} className="group cursor-pointer rounded-md">
      <Card
        interactive
        className={clsx(
          'flex h-28 w-45 items-center border bg-white',
          selected && 'border-primary shadow-floating-container',
        )}
      >
        <RadioButton id={id} value={value} className="sr-only" />
        <CardContent className="flex flex-col items-center gap-6 py-0 text-center">
          <Icon className="icon-lg" />
          <span className="flex flex-col">
            <Text fontWeight="bold" fontSize="md">
              {title}
            </Text>
            <Text
              fontSize="sm"
              variant="secondary"
              className={clsx('text-nowrap')}
            >
              {description}
            </Text>
          </span>
        </CardContent>
      </Card>
    </Label>
  )
}
